/*
  Salt & Tide Co store tweaks.
  1. Open the cart drawer automatically after something is added.
  2. Product page: trust line under the buy buttons.
  (The Afterpay line under the price now comes from the theme's "Afterpay line" block, blocks/st-afterpay-line.liquid.)
*/
(function () {
  if (window.__stStoreTweaks) return;
  window.__stStoreTweaks = true;

  // 1. Auto open cart drawer. The theme opens it when the drawer has the auto-open attribute.
  function enableAutoOpen() {
    document.querySelectorAll('cart-drawer-component').forEach(function (el) {
      if (!el.hasAttribute('auto-open')) el.setAttribute('auto-open', '');
    });
  }
  // The theme refreshes the drawer during an add, which can drop the attribute,
  // so after a successful add from a product form we also open the drawer directly.
  window.addEventListener('cart:update', enableAutoOpen, true);
  document.addEventListener('cart:update', function (e) {
    var data = (e.detail && e.detail.data) || {};
    if (data.didError) return;
    if (data.source !== 'product-form-component') return;
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer-component');
      var dialog = drawer && drawer.querySelector('dialog');
      if (drawer && dialog && !dialog.open && typeof drawer.open === 'function') {
        drawer.open();
      }
    }, 60);
  });

  // 2. Product page trust line.
  function mainForm() {
    return document.querySelector('product-form-component[data-section-id*="__main"]') ||
      document.querySelector('main product-form-component');
  }

  function addLines() {
    var form = mainForm();
    if (!form) return;

    // Remove any old script made Afterpay line (replaced by the theme block).
    document.querySelectorAll('p.st-afterpay').forEach(function (el) { el.remove(); });

    // Trust line
    var buy = form.closest('.buy-buttons-block') || form;
    if (buy && !buy.parentNode.querySelector('.st-trust')) {
      var trust = document.createElement('p');
      trust.className = 'st-trust';
      trust.textContent = 'Free shipping over $150 · 14 day exchanges · Click & Collect in Warrnambool';
      buy.insertAdjacentElement('afterend', trust);
    }
  }

  var style = document.createElement('style');
  style.textContent =
    '.st-trust{margin:10px 0 0;font-size:13px;line-height:1.5;text-align:center;opacity:.85;color:var(--color-foreground);}';
  document.head.appendChild(style);

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      enableAutoOpen();
      addLines();
    });
  }

  function start() {
    enableAutoOpen();
    addLines();
    var main = document.querySelector('main') || document.body;
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('variant:update', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
